import React from 'react';
import { Avatar, Grid, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import School from '@mui/icons-material/School';
import { CalendarToday, Favorite, Language, Room, Visibility } from '@mui/icons-material';
import { ReactComponent as WorkStation } from '@/assets/images/work-station.svg';
import {
  StyledAboutSectionFirst,
  StyledAboutSectionPersonal,
  StyledAboutSectionProfessional,
  StyledAboutSectionSecond,
  StyledAboutSectionWrapper,
  StyledContainer,
  StyledResumeContainer,
} from './styles';
import { StyledButton } from '@/styles/commonStyles';
import colors from '@/styles/colors';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';
import { getExperience } from '@/utils/commonFunctions';

export default function AboutMe() {
  const {
    externalLinks: { resume },
    personalData: { aboutMe, DOBY },
  } = GLOBAL_CONSTANTS;
  const handleLinkClick = (id) => {
    const ele = document.getElementById(id);
    if (ele) {
      ele.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'center' });
    }
  };

  const getAge = () => {
    const birthYear = DOBY;
    const currentYear = new Date().getFullYear();
    const years = currentYear - birthYear;
    return `${years} Years`;
  };

  return (
    <StyledContainer id="about">
      <StyledAboutSectionWrapper>
        <StyledAboutSectionProfessional>
          <StyledAboutSectionFirst>
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
              Hi, I&apos;m Papu Kumar.
              <br className="hidden lg:inline-block" />I love to build amazing apps.
            </h1>
            <p className="mb-8 leading-relaxed">{aboutMe.replace('#exp', getExperience())}</p>
            <div className="flex justify-center">
              <StyledButton variant="outlined" sx={{ marginRight: '8px' }} color="secondary" onClick={() => handleLinkClick('contact')}>
                Work With Me
              </StyledButton>
              <StyledButton variant="outlined" color="success" onClick={() => handleLinkClick('projects')}>
                See My Past Work
              </StyledButton>
            </div>
          </StyledAboutSectionFirst>
          <StyledAboutSectionSecond>
            <WorkStation />
          </StyledAboutSectionSecond>
        </StyledAboutSectionProfessional>
        <StyledAboutSectionPersonal>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6} md={6} lg={6} justifyContent="center" display="flex">
              <List
                sx={{
                  '& .MuiListItemText-secondary': {
                    color: colors.light,
                  },
                }}
              >
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ backgroundColor: colors.primary }}>
                      <School />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Degree" secondary="B.Tech C.S.E." />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ backgroundColor: colors.primary }}>
                      <Room />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Current" secondary="DLF Phase III, Gurugram" />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ backgroundColor: colors.primary }}>
                      <Favorite />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Interests" secondary="Music, Anime, Cooking, Calligraphy, and Coding" />
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} justifyContent="center" display="flex">
              <List
                sx={{
                  '& .MuiListItemText-secondary': {
                    color: colors.light,
                  },
                }}
              >
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ backgroundColor: colors.primary }}>
                      <CalendarToday />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Age" secondary={getAge()} />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ backgroundColor: colors.primary }}>
                      <Room />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Native" secondary="Saran, Bihar, India" />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ backgroundColor: colors.primary }}>
                      <Language />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Languages" secondary="English and Hindi" />
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </StyledAboutSectionPersonal>
        <StyledResumeContainer>
          <StyledButton
            variant="outlined"
            href={resume}
            sx={{ color: colors.primary, borderColor: colors.primary }}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<Visibility />}
            size="large"
          >
            SEE MY RESUME
          </StyledButton>
        </StyledResumeContainer>
      </StyledAboutSectionWrapper>
    </StyledContainer>
  );
}
